import axios from "axios";
import { api } from "./helper";
import CryptoJS from 'crypto-js';
import Utils from "@/project/Source/utils.js";

const client = axios.create({
    baseURL: api,
    withCredentials: false,
});

client.interceptors.request.use((config) => {
    const jwt = window.localStorage.getItem('jwt');
    config.headers.Authorization = "Bearer " + JSON.parse(CryptoJS.AES.decrypt(jwt, 'secret_key').toString(CryptoJS.enc.Utf8));
    return Utils.applyRequestCorrelationId(config);
});

client.interceptors.response.use(
    (response) => {
        if (response.data.isSuccess)
            return response;
        else {
            const message = Utils.FormatErrorWithCorrelationId(null, response);
            Utils.Alert(message);
        }
    },
    (error) => {
        if (error.response?.status === 401) {
            Utils.redirectToLoginOnUnauthorized();
            return Promise.reject(error);
        }
        const message = Utils.FormatErrorWithCorrelationId(error);
        Utils.Alert(message);
        return Promise.reject(error);
    }
);


function PolicySerie(item) {
    return client.post("Core/PolicySerie", item);
}
function PolicySerieById(item) {
    return client.post("Core/PolicySerieById", item);
}
function ReinsType(item) {
    return client.post("Core/ReinsType", item);
}
function Installment(item) {
    return client.post("Core/Installment", item);
}
function NewInstallmentRequest(item) {
    return client.post("Core/NewInstallmentRequest", item);
}
function DropInstallmentRequest(item) {
    return client.post("Core/DropInstallmentRequest", item);
}
function EditInstallmentRequest(item) {
    return client.post("Core/EditInstallmentRequest", item);
}
function Payment(item) {
    return client.post("Core/Payment", item);
}
function NewPaymentRequest(item) {
    return client.post("Core/NewPaymentRequest", item);
}
function DropPaymentRequest(item) {
    return client.post("Core/DropPaymentRequest", item);
}
function EditPaymentRequest(item) {
    return client.post("Core/EditPaymentRequest", item);
}
function AddendumInstallment(item) {
    return client.post("Core/AddendumInstallment", item);
}
function PayTypeAll(item) {
    return client.post("Core/PayTypeAll", item);
}

function PolicyPaymentStatus(item) {
    return client.post("Core/PolicyPaymentStatus", item);
}

function AgentsByInsure(item) {
    return client.post("Core/AgentsByInsure", item);
}

function Country(item) {
    return client.post("Core/Country", item);
}

function Town(item) {
    return client.post("Core/Town", item);
}

export default {
    PolicySerie,
    PolicySerieById,
    ReinsType,
    Installment,
    NewInstallmentRequest,
    DropInstallmentRequest,
    EditInstallmentRequest,
    Payment,
    NewPaymentRequest,
    DropPaymentRequest,
    EditPaymentRequest,
    AddendumInstallment,
    PayTypeAll,
    AgentsByInsure,
    Country,
    Town,
    PolicyPaymentStatus
}